var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglesheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43171 10.4542H4.59171V8.86333H7.43337V10.455L7.43171 10.4542ZM10.2734 0V5H15.2734L10.2734 0ZM11.4092 8.86333H8.56754V10.455H11.4092V8.86333ZM11.4092 11.5908H8.56754V13.1825H11.4092V11.5908ZM15.2725 5.41667V18.6367C15.2725 19.39 14.6625 20 13.9092 20H2.09087C1.91184 20 1.73455 19.9647 1.56915 19.8962C1.40374 19.8277 1.25345 19.7273 1.12685 19.6007C0.871176 19.345 0.727539 18.9982 0.727539 18.6367V1.36333C0.727539 0.61 1.33754 0 2.09087 0H9.85587V5.41667H15.2725ZM12.545 7.7275H3.45421V14.3183H12.5459V7.72667L12.545 7.7275ZM7.43171 11.5908H4.59171V13.1825H7.43337V11.5908H7.43171Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglesheets);
export default __webpack_public_path__ + "static/media/googlesheets.f3afabe4368110b4ec2af5c28c6a8dc7.svg";
export { ForwardRef as ReactComponent };